import { createStore, applyMiddleware, compose } from "redux";
import createReducer from "./redux";
import apiMiddleware from "./middleware/api";
import promiseMiddleware from "./middleware/promise";
import logoutMiddleware from "./middleware/logout";
import thunkMiddleware from "./middleware/thunk";

export default function configureStore() {
  const middlewares = [
    thunkMiddleware,
    apiMiddleware,
    promiseMiddleware,
    logoutMiddleware
  ];

  const enhancers = [applyMiddleware(...middlewares)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers =
    process.env.NODE_ENV !== "production" &&
    typeof window === "object" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Prevent recomputing reducers for `replaceReducer`
          shouldHotReload: false
        })
      : compose;

  const store = createStore(createReducer(), composeEnhancers(...enhancers));

  // Extensions
  store.injectedReducers = {}; // Reducer registry

  // Make reducers hot reloadable
  if (module.hot) {
    module.hot.accept("./redux", () => {
      store.replaceReducer(createReducer(store.injectedReducers));
      store.dispatch({ type: "@@REDUCER_INJECTED" });
    });
  }

  return store;
}
